import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { FiLock, FiMoreVertical, FiSearch, FiShield, FiSliders } from 'react-icons/fi';
import { HOME_EASE, HomeFloat } from './HomeMotion';
import vaultPhoto from '../../../images/home/vault-photo.png';

const ITEMS = [
  { name: 'Google Workspace', time: '2m ago', mark: 'G', tone: 'google' },
  { name: 'AWS Production', time: '1h ago', mark: 'A', tone: 'aws' },
  { name: 'Slack Admin', time: '3h ago', mark: 'S', tone: 'slack' },
  { name: 'Stripe API Key', time: '1d ago', mark: 'S', tone: 'stripe' },
  { name: 'Personal GitHub', time: '2d ago', mark: 'G', tone: 'github' },
];

const HomeVaultVisual = () => {
  const reduce = useReducedMotion();

  return (
    <div className="home-vault-stage">
      <div className="home-vault-photo-wrap">
        <motion.img
          src={vaultPhoto}
          alt="Professional working securely at a laptop"
          className="home-vault-photo"
          draggable="false"
          initial={reduce ? false : { opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.28 }}
          transition={{ duration: 0.7, ease: HOME_EASE }}
        />
      </div>

      <HomeFloat
        className="home-float--vault-panel"
        cardClassName="home-float-card--vault-panel"
        enterDelay={0.22}
        inView
        drift={{ x: 4, y: -10, duration: 5.4, durationX: 6.8 }}
      >
        <header className="home-vault-panel-head">
          <span className="home-vault-panel-icon">
            <FiLock />
          </span>
          <div>
            <strong>My Vault</strong>
            <p>All items</p>
          </div>
          <FiMoreVertical />
        </header>

        <div className="home-vault-search">
          <span className="home-vault-search-field">
            <FiSearch />
            Search credentials
          </span>
          <span className="home-vault-filter">
            <FiSliders />
          </span>
        </div>

        <ul className="home-vault-items">
          {ITEMS.map((item, index) => (
            <motion.li
              key={item.name}
              initial={reduce ? false : { opacity: 0, y: 8 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.32 + index * 0.08, ease: HOME_EASE }}
            >
              <span className={`home-vault-mark is-${item.tone}`}>{item.mark}</span>
              <div>
                <strong>{item.name}</strong>
                <small>••••••••</small>
              </div>
              <em>{item.time}</em>
              <FiLock />
            </motion.li>
          ))}
        </ul>

        <div className="home-vault-foot">
          <span className="home-vault-foot-icon">
            <FiShield />
          </span>
          <div>
            <strong>Vault Security Score</strong>
            <p>Strong security</p>
          </div>
          <motion.b
            initial={reduce ? false : { opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: 0.7, ease: HOME_EASE }}
          >
            96%
          </motion.b>
        </div>
      </HomeFloat>
    </div>
  );
};

export default HomeVaultVisual;
